import { TeacherTrainingCourseBanner, TeacherTrainingCoursesConfig } from '@yandex-int/k-common';
import { getTeacherTrainingCoursesConfig } from 'platform-components/src/components/app-factory/selectors';
import { createSelector } from 'reselect';

import { getClasses } from 'common.components/user/selectors';

import type { ReduxTeacherKPKsStore } from './types';

const TeacherTrainingCoursesSelector = (storeState: ReduxTeacherKPKsStore) => storeState?.teacherKPKs;

const getTeacherGrades = createSelector([getClasses], (teams): number[] => {
    if (!teams) {
        return [];
    }

    return [...new Set(teams.map((team) => team.level))];
});

const getTeacherKPKs = createSelector([TeacherTrainingCoursesSelector], (store) => store.teacherKPKs);
const getTeacherKPKsByClass = createSelector([getTeacherKPKs, getTeacherGrades], (kpks, teacherGrades) =>
    kpks.filter(({ grades }) => (grades?.length ? grades.some((grade) => teacherGrades.includes(grade)) : true))
);
const getTeacherKPKsStream = createSelector([TeacherTrainingCoursesSelector], (store) => store.teacherKPKsStream);
const getGetTeacherKPKsLoading = createSelector(
    [TeacherTrainingCoursesSelector],
    (store) => store.getTeacherKPKsLoading
);

const getPostTeacherKPKJoinLoading = createSelector(
    TeacherTrainingCoursesSelector,
    (storeState) => storeState.postTeacherKPKJoinLoading
);

const getPostTeacherKPKJoinByCodeLoading = createSelector(
    TeacherTrainingCoursesSelector,
    (storeState) => storeState.postTeacherKPKJoinByCodeLoading
);
const getJoinByCodeErrorId = createSelector(
    TeacherTrainingCoursesSelector,
    (storeState) => storeState.teacherKPKJoinByCodeErrorId
);

const getPostTeacherKPKsUpdateThreadLoading = createSelector(
    [TeacherTrainingCoursesSelector],
    (store) => store.postTeacherKPKsUpdateThreadLoading
);

/** Не используется (бункер пустой) */
const getTeacherTrainingCoursesBannerList = createSelector(
    [getTeacherTrainingCoursesConfig],
    (teacherTrainingCoursesConfig: TeacherTrainingCoursesConfig): TeacherTrainingCourseBanner[] =>
        teacherTrainingCoursesConfig?.banners || []
);

export const teacherKPKsSelectors = {
    getTeacherKPKs,
    getTeacherKPKsByClass,
    getTeacherKPKsStream,
    getGetTeacherKPKsLoading,

    getPostTeacherKPKJoinLoading,

    getPostTeacherKPKJoinByCodeLoading,
    getJoinByCodeErrorId,

    getPostTeacherKPKsUpdateThreadLoading,

    getTeacherTrainingCoursesBannerList,
};
